import { motion } from "framer-motion";
import { Instagram, Play } from "lucide-react";

const CARDS = [
  {
    thumb: "/media/reels/reel1.jpg",
    title: "Designed with intent.",
    desc: "Take a quick walk through our Vile Parle space — designed for physiotherapy, strength training and everything in between.",
    url: "https://www.instagram.com/reel/DaH5QwpsITP/?igsh=MXhvZ3hqODMzOGVxYg==",
  },
  {
    thumb: "/media/reels/reel2.jpg",
    title: "42. Strength still matters.",
    desc: "I may be 42, but mentally I'm still 21. Here's my simple strength checklist for keeping the body somewhere close.",
    url: "https://www.instagram.com/reel/DadU5gioqQa/?igsh=MWV0bXNqcGQ4eXRjNg==",
  },
  {
    thumb: "/media/reels/reel3.jpg",
    title: "PLST goes for a walk.",
    desc: "For Women's Day, Dr Pradnya took our Thane PLST group out of the studio and into NaMo Central Park — because movement and community belong together.",
    url: "https://www.instagram.com/reel/DVmm_ngCOVH/?igsh=MXhscjkxczR5MzdjMQ==",
  },
];

export default function InsidePLST() {
  return (
    <section id="inside" className="py-24 lg:py-40 bg-white border-y border-[#1E1E1E]/10" data-testid="inside-plst-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.8 }} className="md:col-span-7"
          >
            <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
              <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
              Inside PLST
            </div>
            <h2 className="mt-6 italic font-medium text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Inside <span className="text-[#A67C00]">PLST.</span>
            </h2>
          </motion.div>
          <p className="md:col-span-5 text-[#1E1E1E]/70 leading-relaxed">
            A closer look at how we train, think and build the PLST community.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 md:overflow-visible overflow-x-auto snap-x md:snap-none">
          {CARDS.map((c, i) => (
            <motion.a
              key={i}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group block bg-[#F5F4EF] border border-[#1E1E1E]/10 hover:border-[#A67C00] transition-colors overflow-hidden snap-start min-w-[280px] md:min-w-0"
              data-testid={`inside-card-${i}`}
            >
              <div className="relative w-full bg-[#222] overflow-hidden" style={{ aspectRatio: "9 / 16" }}>
                <img
                  src={c.thumb}
                  alt=""
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  draggable={false}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40 pointer-events-none" />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="w-14 h-14 rounded-full bg-white/85 backdrop-blur flex items-center justify-center group-hover:bg-[#A67C00] group-hover:text-white transition-colors">
                    <Play size={22} className="ml-1" />
                  </div>
                </div>
                <div className="absolute top-3 right-3 text-white/95">
                  <Instagram size={18} />
                </div>
              </div>
              <div className="p-6 lg:p-7">
                <h3 className="font-display font-semibold text-lg md:text-xl tracking-tight text-[#1E1E1E] leading-snug">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm text-[#1E1E1E]/70 leading-relaxed">{c.desc}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[#A67C00] font-semibold">
                  Watch on Instagram <span className="transition-transform group-hover:translate-x-1">→</span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
